appSocial.filter('duration', ['SocialLocaleService', 'moment',
    function (SocialLocaleService, moment) {
        const translation = SocialLocaleService.translation;
        return function (sec, format) {
            const duration = moment.duration(sec, 'seconds');
            const n = 24 * 60 * 60 * 1000;
            const days = Math.floor(duration.asDays());
            const hours = Math.floor(duration.asHours());
            const weeks = Math.floor(duration.asWeeks());
            const months = Math.floor(duration.asMonths());
            const minutes = Math.floor(duration.asMinutes());
            const seconds = Math.floor(duration.asSeconds());

            let str = '';

            if (format === 'exact') {
                str = moment.duration(sec, "seconds")
                    .format("d [days] hh:mm:ss")
                return str;
            }

            if (months > 0) {
                return `${months} ${months == 1 ? translation.month : translation.months}`;
            }

            if (weeks > 0) {
                return `${weeks} ${weeks == 1 ? translation.week : translation.weeks}`;
            }

            if (days > 0) {
                return `${days} ${days == 1 ? translation.day : translation.days}`;
            }

            if (hours > 0) {
                return `${hours} ${hours == 1 ? translation.hour : translation.hours}`;
            }

            if (minutes > 0) {
                return `${minutes} ${minutes == 1 ? translation.minute : translation.minutes}`;
            }

            if (seconds > 0) {
                return `${seconds} ${seconds == 1 ? translation.second : translation.seconds}`;
            }

            return str;
        }
    }]);
